import { ReactNode, PropsWithChildren } from "react";
import { Button, Divider, Typography } from "../../../main";
import cx from "classnames";

import styles from "./promobox.module.css";

const { Heading } = Typography;
const { SubHeading2, SubHeading4 } = Heading;

export default function PromoBox({
  label,
  title,
  ctaLabel,
  ctaUrl,
  children,
}: PropsWithChildren<{
  label?: string;
  title?: string;
  ctaLabel?: string;
  ctaUrl?: string;
}>): ReactNode {
  return (
    <div className={cx(styles.promoBox, styles.boxShadow)}>
      <div className={styles.heading}>
        {label && <SubHeading4>{label}</SubHeading4>}
        <SubHeading2>{title}</SubHeading2>
        <div className={styles.divider}>
          <Divider size="sm" />
        </div>
      </div>

      {children}

      {ctaLabel && ctaUrl && (
        <div className={styles.cta}>
          <Button variant="primary" href={ctaUrl}>
            {ctaLabel}
          </Button>
        </div>
      )}
    </div>
  );
}
